import Blue from "~/core";

new Blue({
	name: 'Skip Link',
	selector: ".js-search-skip",
	setup(skipLink) {
        const searchTrigger = document.querySelector('.search__trigger');
        this.$addEvents(skipLink, 'click.prevent enter.prevent', (e) => {
            document.location.hash = "#search"
            searchTrigger.click()
        });
	}
});